import { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
	const [cart, setCart] = useState({ items: [] });
	const [loading, setLoading] = useState(false);

	// ✅ użyj useCallback, by funkcja była stabilna
	const fetchCart = useCallback(async () => {
		try {
			setLoading(true);
			const token = localStorage.getItem("authToken");
			if (!token) {
				setCart({ items: [] });
				return;
			}

			const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cart`, {
				headers: { Authorization: `Bearer ${token}` },
			});

			setCart(response.data || { items: [] });
		} catch (err) {
			console.error("Błąd pobierania koszyka:", err);
			setCart({ items: [] });
		} finally {
			setLoading(false);
		}
	}, []); // 🔒 dzięki temu fetchCart nie zmienia referencji przy każdym renderze

	useEffect(() => {
		fetchCart(); // załaduj koszyk przy starcie
	}, [fetchCart]);

	return (
		<CartContext.Provider value={{ cart, setCart, fetchCart, loading }}>
			{children}
		</CartContext.Provider>
	);
};
